import Vue from 'vue'
import {ButtonPlugin, FormCheckboxPlugin, FormInputPlugin, InputGroupPlugin, ToastPlugin, TooltipPlugin} from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faBalanceScaleLeft, faCheck, faCopy, faClock, faInfoCircle, faTimes, faTrashAlt} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import App from "@/App"

import '@/assets/custom.scss'


Vue.config.productionTip = false

const router = new VueRouter({
  mode: 'history',
})
Vue.use(VueRouter)

Vue.use(ButtonPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ToastPlugin)
Vue.use(TooltipPlugin)

Vue.use(VueClipboard)

Vue.use(VueAnalytics, {
  id: 'UA-40529518-24',
  set: [
    { field: 'anonymizeIp', value: true }
  ],
  disabled: () => {
    return localStorage.getItem('ga-enabled') !== 'true'
  },
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  },
  router,
  autoTracking: {
    skipSamePath: true
  },
})

library.add(faBalanceScaleLeft, faCheck, faClock, faCopy, faInfoCircle, faTrashAlt, faTimes)
Vue.component('fas-icon', FontAwesomeIcon)


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
